import api from './api';

function extractNotificationCollection(payload) {
  if (Array.isArray(payload)) {
    return payload;
  }

  if (!payload || typeof payload !== 'object') {
    return [];
  }

  const candidateKeys = [
    'notifications_list',
    'notifications',
    'notification',
    'items',
    'data',
    'rows',
    'list',
    'result',
  ];

  for (const key of candidateKeys) {
    const candidate = payload[key];

    if (Array.isArray(candidate)) {
      return candidate;
    }

    if (candidate && typeof candidate === 'object') {
      const nestedItems = extractNotificationCollection(candidate);
      if (nestedItems.length > 0) {
        return nestedItems;
      }
    }
  }

  return [];
}

function extractPagination(payload) {
  const pagination = payload?.pagination;

  return {
    currentPage: Number(pagination?.currentPage || pagination?.current_page || 1),
    perPage: Number(pagination?.perPage || pagination?.per_page || 0),
    totalRecords: Number(pagination?.totalRecords || pagination?.total_records || 0),
    totalPages: Number(pagination?.totalPages || pagination?.total_pages || 1),
  };
}

export async function fetchNotifications({ page = 1, unreadOnly = false } = {}) {
  const response = await api.get('/notification/get-notifications', {
    params: {
      page,
      ...(unreadOnly ? { read_status: 1 } : {}),
    },
  });
  if (response.status !== 200) {
    throw new Error('Unable to load notifications.');
  }
  const payload = response?.data?.dataset?.data ?? response?.data?.data ?? response?.data ?? {};

  return {
    items: extractNotificationCollection(payload),
    pagination: extractPagination(payload),
  };
}

export async function markNotificationSeen(notificationLogId) {
  return api.post('/notification/update-notification-seen-status', {
    notification_log_id: notificationLogId,
  });
}
